import { FauxTable, FauxTableRow } from "@components/FauxTable";
import { formatDate, isValidDate } from "@utils/dates";
import { addressColumn, dateColumn, genericColumn, primaryRelationshipColumn, selectColumn } from "./columnHelpers";

export const businessLocationsRelationship = {
    collapsible: false,
    title: 'Business Locations',
    tint: 'property',
    type: 'table',
    sx: {
        '--mm-card-height': 'auto',
    },
    columns: [
        addressColumn,
        genericColumn({
            label: 'Unit',
            render: {
                show: (object, parentObject) => {
                    const unitId = object?.pivot?.property_unit_id;
                    if(!unitId) {
                        return null;
                    }

                    const foundUnit = object.property_units?.find(unit => unit.id === unitId);

                    return foundUnit?.unit;
                },
            },
        }),
        genericColumn({
            label: 'History',
            render: {
                show: (object) => {
                    const isValidMovedInDate = isValidDate(object.pivot.date_entered);
                    const isValidMovedOutDate = isValidDate(object.pivot.date_left);
                    return (
                        <FauxTable>
                            <FauxTableRow title={'Moved In'} breakTitle={false}>
                                {isValidMovedInDate && (<time>{formatDate(object.pivot.date_entered)}</time>)}
                                {!isValidMovedInDate && (<>N/A</>)}
                            </FauxTableRow>
                            <FauxTableRow title={'Moved Out'} breakTitle={false}>
                                {isValidMovedOutDate && (<time>{formatDate(object.pivot.date_left)}</time>)}
                                {!isValidMovedOutDate && (<>N/A</>)}
                            </FauxTableRow>
                        </FauxTable>
                    );
                },
            },
        }),
    ],
};

export const businessLocationsRelationshipEdit = {
    collapsible: false,
    title: 'Business Locations',
    tint: 'property',
    type: 'table',
    sx: {
        '--mm-card-height': 'auto',
    },
    columns: [
        primaryRelationshipColumn({
            label: 'Address',
            column: 'address',
            endpoint: 'properties',
            include: 'property_units',
        }),
        selectColumn({
            label: 'Unit',
            column: 'pivot.property_unit_id',
            enabled: (row, object) => {
                // console.log(row);
                return row?.property_units?.length > 0;
            },
            options: (row, object) => {
                return row?.property_units ?? [];
            },
        }),
        dateColumn({label: 'Moved In', column: 'pivot.date_entered'}),
        dateColumn({label: 'Moved Out', column: 'pivot.date_left'}),
    ],
};
